const VALID_COLUMNS = {
  id: 'id',
  confirmed: 'confirmed',
  name: 'name',
  severity: 'severity',
  tags: 'tags',
  risk: 'risk',
  cvss: 'cvss3',
  hostnames: 'hostnames',
  create_date: 'date',
  cve: 'cve',
  cwe: 'cwe',
  path: 'path',
  owasp: 'owasp',
  service__name: 'service',
  tool: 'tool',
  status: 'status',
  status_history: 'status_history',
  issuetracker: 'issuetracker',
  asset: 'target',
  easeofresolution: 'easeofresolution',
  external_id: 'external_id',
  method: 'method',
  query: 'query',
  status_code: 'status_code',
  website: 'website',
  host__os: 'host_os',
  impact: 'impact',
  update_date: 'update_date',
  last_detected: 'last_detected',
  web: 'type',
  workspace_name: 'workspace_name',
  description: 'description',
  data: 'data',
  request: 'request',
  resolution: 'resolution',
  response: 'response'
};

export default VALID_COLUMNS;
